var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-page',[_c('app-page-head',{attrs:{"title":"Analytics"}}),_c('app-page-content',{staticClass:"share",attrs:{"is-padded":true}},[_vm._v(" abc ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }